<template>
  <div class="main_header" >
    <div class="centered">
        <div class="content">
            <div class="logo_menu">
                <ol>
                    <li class="logo_container">
                        <router-link :to="mainPageLink" class="logo"></router-link>
                    </li>
                    <li v-for="option in menu" :key="option.name" :class="{ active: option.to.name == $route.name}">
                        <router-link :to="option.to">{{ option.name }}</router-link>
                    </li>
                </ol>
            </div>
            <div class="profile_company" v-click-away="() => {is_actions_open = false}">
                <div class="company_name" v-text="get_me().company_name"></div>
                <div class="username_actions" :class="{active: is_actions_open}" @click="is_actions_open = !is_actions_open">
                    <div class="username_icon">
                        <div class="user_pic icon" :style="'background-image: url(' + get_me().pic_parsed + ')'"></div>
                        <span class="username" v-text="get_me().name"> </span>
                        <div class="icon" :class="is_actions_open ? 'chevron_up_icon' : 'chevron_down_icon'"></div>
                    </div>
                    <div class="dropdown_actions">
                        <ul>
                            <router-link :to="{name: 'edit_profile'}">
                                <div class="text">עריכת פרופיל</div>
                                <div class="icon settings_icon"></div>
                            </router-link>
                            <router-link :to="{name: 'updates'}">
                                <div class="text">עדכונים</div>
                                <div class="icon settings_icon"></div>
                            </router-link>
                            <!-- <li>
                                <div class="text">עזרה</div>
                                <div class="icon help_icon"></div>
                            </li> -->
                            <li @click="logout()">
                                <div class="text">יציאה</div>
                                <div class="icon log_out_icon"></div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="noti_con">
                    <div class="updates" @click="is_updates_open=!is_updates_open">
                        <div class="head">
                            <span class="have_updates" v-if="show_have_updates"></span>
                            <i class="fas fa-bell"></i>
                        </div>
                        <router-link :to="{name: 'updates'}" class="small_updates" :class="{active: is_updates_open}">
                            <ul>
                                <template v-if="$store.last_updates?.length">
                                    <li v-for="item in this.$store.last_updates" :key="item.title">
                                        <h5 v-text="removeHtml(item.title)"></h5>
                                        <p v-text="removeHtml(item.desc)"></p>
                                    </li>
                                </template>
                                <template v-else>
                                    <li>
                                        <h5>אין עדכונים חדשים</h5>
                                    </li>

                                </template>
                            </ul>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    // props: [ "menu" ],
    data() {
        return {
            is_actions_open: false,
            is_updates_open: false,
            show_have_updates:false,
            menu: []
        }
    },
    mounted() {
        console.log(this.get_me());
        this.menu.push({ name: 'חברים במכרז השקוף', to: { name: 'friends'}})
        if (this.get_me().type == 'entrepreneur') {
            this.menu.push({ name: 'מכרזים פעילים', to: { name: 'projects'}})
        } else if (this.get_me().type == 'lawyer') {
            this.menu.push({ name: 'רשימת מכרזים', to: { name: 'projects_manager'}})
        }
        console.log(this.$store.last_updates);
        
        this.show_have_updates = this.$store.last_updates.some(item => !(+item.is_watch))
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.main_header { z-index: 9999; position: fixed; top: 0; right: 0; left: 0; background: var(--dark_blue);
    .content {display: flex; justify-content: space-between; align-items: center; height: var(--headerHeight);}
    .logo_menu {display: flex; 
        ol {display: flex; gap: 32px; list-style: none; font-family: var(--font2);
            .logo_container {
                .logo { display: block; background-image: url(@/assets/logo.svg); background-position: center center; background-size: contain; background-repeat: no-repeat;    height: 30px; width: 200px;}
            }
            li { color: var(--light_blue);
                &:not(:first-child) { border-bottom: 2px solid transparent; transition: ease 0.2s border-bottom;
                    &:hover {
                        border-bottom: 2px solid #fff;
                    }
                }
                a {font-size: var(--h4); color: var(--light_blue);  font-family: var(--font2);}

                &.active { 
                    a { color: #fff;}
                }
            }
        }
    }
    .profile_company { display: flex; align-items: stretch; gap: var(--gap);
        .company_name { color: #fff; position: relative; margin-left: var(--gap); display: flex; align-items: center; font-size: var(--h5); padding-block: 2px;
            &::after {content: ''; position: absolute; top: 0; bottom: 0; left: calc(var(--gap) * -1); background: #4D7E99; width: 1px; }

        }

        .username_actions {position: relative;  min-width: 140px;
            &.active {
                .username_icon {
                    background: var(--text_s); border-radius: var(--radius_s);
                }
                .dropdown_actions {display: block;}
            }
            .user_pic { border-radius: 50%; height: 40px; width: 40px; background-color: #fff; }
            .username_icon { justify-content: space-between; width: 100%; display: flex; gap: 10px; align-items: center; padding: 5px 10px; cursor: pointer;
                .username { font-size: var(--h5); color: #fff;}
            }
            .dropdown_actions {display: none; position: absolute; right: 0; left: 0; bottom: -4px; transform: translateY(100%); 
                ul { display: flex; flex-direction: column;border-radius: var(--radius_s); background: var(--dark_blue);
                    li, &>a { cursor: pointer; display: flex; align-items: center; justify-content: space-between; padding-block: 8px; padding-inline: 24px 16px; 
                        .text {color: #fff; font-size: var(--h5);}
                    }
                }
            }
        }

        .noti_con { display: flex; align-items: center; gap: 10px;
            .updates { cursor: pointer; color: #fff; font-size: var(--h3); position: relative; 
                .have_updates { position: absolute; right: -5px; top: 0px; display: inline-block; width: 9px; height: 9px; background: var(--green_light); border-radius: 50%; }
                .small_updates { transition: ease 0.3s transform; position: absolute; bottom: -15px; right: 7px; transform: translate(100%, 100%); background: var(--blue_ligher); width: 350px; padding: var(--gap); border-radius: 16px; border-start-end-radius: 0;
                    &:not(.active) { transform: translate(50%, 47%) scale(0);}
                    &::before {content: ''; position: absolute; top: 0; left: 0; transform: translateY(calc(-100% + 14px)); border: 14px solid transparent; border-left-color: var(--blue_ligher);}
                    ul {
                        li { padding-block: var(--gap); 
                            &:not(:last-child) { border-bottom: 1px solid #fff;}
                            h5 { font-size: var(--h5);}
                            p { font-weight: 100;  font-size: var(--h6); line-clamp: 1;--webkit-line-clamp: 1; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; overflow: hidden;}
                        }
                    }

                }
            }
        }
    }
}
</style>